// extracted by mini-css-extract-plugin
module.exports = {"description":"ContentBlockImages_description__A7Q_R","image":"ContentBlockImages_image__bM19V","slides":"ContentBlockImages_slides__mfNY_"};